import { useUIStore } from '@/store/ui.store';
import { ProfileDropdownWithFallback } from './profileDropdown';

const Header = () => {
  const isSidebarCollapsed = useUIStore((state) => state.isSidebarCollapsed);

  return (
    <header
      className={`site-header fixed top-0 right-0 z-40 w-[calc(100%_-_50px)] bg-[#0a0a0a] py-5 shadow-2xl transition-all duration-300 ${
        isSidebarCollapsed
          ? 'lg:w-[calc(100%_-_50px)]'
          : 'lg:w-[calc(100%_-_min(16.5%,_280px))]'
      }`}
    >
      <div className='text-stone flex flex-wrap items-center justify-between gap-2 px-4 lg:gap-4 lg:px-10'>
        <p
          id='header-title'
          className='order-1 flex items-center gap-2 text-sm lg:gap-4 lg:text-lg'
        ></p>
        {/* <div className='relative order-3 w-full md:order-2 md:w-[318px] md:max-w-[418px]'>
           <div className={`${showTabSearch ? 'block' : 'hidden'} md:block`}>
             <div className='absolute top-1/2 left-5 z-10 -translate-y-1/2 transform'>
               <IconsComponent
                 icon='regular-search'
                 size='sm'
               />
             </div>
             <Input
               autoFocus={showTabSearch && window.innerWidth < 768}
               className='text-stone placeholder:text-stone w-full border border-solid border-white/5 bg-white/5 py-2 pl-12'
               placeholder='Search here ...'
             />
           </div>
         </div> */}
        <div className='order-2 flex flex-wrap items-center gap-4 md:order-3'>
          {/* <div className='flex items-center md:hidden'> 
             <button onClick={toggleSearch}> 
               <IconsComponent
                 icon={showTabSearch ? 'regular-x' : 'regular-search'}
                 size='sm'
               />
             </button>
           </div>
           <Link to={PROTECTED_ROUTES.DASHBOARD.SETTINGS}>
             <IconsComponent
               icon='regular-tick'
               size='sm'
             /> 
           </Link>
           <Link to={PROTECTED_ROUTES.DASHBOARD.PINNED}>
             <IconsComponent
               icon='regular-pin'
               size='sm'
             />
           </Link>
           <Link to={PROTECTED_ROUTES.DASHBOARD.NOTIFICATION}>
             <IconsComponent
               icon='regular-bell'
               size='sm'
             />
           </Link> */}
          <ProfileDropdownWithFallback />
        </div>
      </div>
    </header>
  );
};

export default Header;
